/**
 * ⛔ MONETARY VALUES ARE NOT RENDERED. One switch, deliberately temporary.
 *
 * Requested by app-api-service on 2026-07-31 —
 * `docs/handoff/2026-07-31-URGENTE-nao-renderizem-valores.md` — before the
 * portal went in front of customers.
 *
 * THE DEFECT IS IN THE PAYLOAD, NOT IN THE FORMATTER. `service-orders/*` sends
 * `currency: 'BRL'` hard-coded: it is a literal, not derived from the
 * franchise. So a Chilean order whose real value is CLP 25.900 arrives as
 * `{amount: 25900, currency: 'BRL'}` and renders `BRL 259,00` — the right
 * formatting of the wrong currency, and 100x low, because BRL has two minor
 * digits and CLP has none.
 *
 * Their note claims we "format by the user's language, not the currency" and
 * that we divide by a fixed 100. Both were checked before this was written and
 * both are wrong about this codebase — `formatMoney` takes the currency from
 * the payload and asks `Intl` for the digit count
 * (`{amount: 25900, currency: 'BRL'}` at `es-CL` gives `BRL 259,00`;
 * `CLP 25900` gives `$25.900`, undivided). The mistaken diagnosis does not
 * change the conclusion: while the payload's currency is a lie, no amount
 * derived from it can be shown.
 *
 * A wrong number about money, in front of the person who owes it, costs more
 * than a missing one — it discredits the screens that ARE correct.
 *
 * ⚠️ WHY A FLAG AND NOT A DELETION. app-api-service kept the fields in the
 *    payload for exactly the same reason: the one-sided change is the safe one.
 *    Deleting the render sites would make restoring them a rewrite; deleting
 *    the fields would break our screens the moment a component still read them.
 *    Nobody renders a field, so nobody sees a wrong number.
 *
 * TO TURN MONEY BACK ON, all of this must be true:
 *   1. `currency` is DERIVED from the franchise, not a literal — they will
 *      derive it from `franquias.pais`, which today holds both `'Brasil'`
 *      (148 rows) and `'BR'` (8 rows) and needs normalising first;
 *   2. a Chilean order round-trips as CLP and renders `$25.900`, not
 *      `BRL 259,00`;
 *   3. `moneyIsHidden.test.tsx` is updated in the same commit, so flipping
 *      this is a deliberate act with a visible diff — not something that
 *      happens because a test was quietly deleted.
 */
export const MONEY_VISIBLE = false;
